// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3cl9R","content":"LoadingAlert_content__1EtaI"};